export function downloadBase64File(base64Data:string, fileName:string) {
  // Create a temporary anchor element
  const link = document.createElement('a');

  // Set the href to the base64 data
  link.href = base64Data;

  // Set the download attribute with the desired file name
  link.download = fileName;

  // Append the link to the document body and trigger click
  document.body.appendChild(link);
  link.click();

  // Clean up
  document.body.removeChild(link);
}